import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const ICON = L.icon({
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
  iconSize: [25, 41], iconAnchor: [12, 41], popupAnchor: [1, -34], shadowSize: [41, 41],
});

const SELECTED_ICON = L.divIcon({
  className: "",
  html: '<div style="background:#0055FF;width:20px;height:20px;border-radius:50% 50% 50% 0;transform:rotate(-45deg);border:2px solid #fff;box-shadow:0 2px 6px rgba(0,0,0,.4)"></div>',
  iconSize: [20, 20], iconAnchor: [10, 20],
});

export const DispatchMap = ({ markers = [], selectedId, onSelect }) => {
  const mapRef = useRef(null);
  const containerRef = useRef(null);
  const layerRef = useRef(null);

  useEffect(() => {
    if (mapRef.current || !containerRef.current) return;
    const map = L.map(containerRef.current, { zoomControl: true }).setView([32.0, -102.0], 6);
    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19, attribution: "&copy; OpenStreetMap",
    }).addTo(map);
    mapRef.current = map;
    layerRef.current = L.layerGroup().addTo(map);
    setTimeout(() => map.invalidateSize(), 200);
  }, []);

  useEffect(() => {
    const map = mapRef.current;
    const layer = layerRef.current;
    if (!map || !layer) return;
    layer.clearLayers();
    const pts = [];
    markers.forEach((m) => {
      if (m.lat == null || m.lng == null) return;
      const isSel = m.id === selectedId;
      const marker = L.marker([m.lat, m.lng], { icon: isSel ? SELECTED_ICON : ICON });
      marker.bindPopup(`<b>${m.label}</b><br/>${m.sub || ""}`);
      marker.on("click", () => onSelect && onSelect(m.id));
      marker.addTo(layer);
      pts.push([m.lat, m.lng]);
      if (isSel) marker.openPopup();
    });
    if (selectedId) {
      const sel = markers.find((m) => m.id === selectedId);
      if (sel && sel.lat != null) map.setView([sel.lat, sel.lng], 9, { animate: true });
    } else if (pts.length) {
      map.fitBounds(pts, { padding: [40, 40], maxZoom: 8 });
    }
  }, [markers, selectedId, onSelect]);

  return <div ref={containerRef} data-testid="dispatch-map" className="h-full w-full rounded-md overflow-hidden border border-border/60" style={{ minHeight: 400 }} />;
};
